import { ReactNode } from "react"
import cx from "classnames"
import styles from "./index.module.css"

/* Composición local del patrón app del DS 2026 (handoff docs/design-handoff-2026).
   Candidato a componente de librería: tutellus-components (hueco nº1 del handoff). */

export const EYEBROW_TONES = {
  BRAND: "brand",
  INFO: "info",
  SUCCESS: "success",
} as const

export type EyebrowTone = (typeof EYEBROW_TONES)[keyof typeof EYEBROW_TONES]

interface EyebrowProps {
  readonly children: ReactNode
  readonly tone?: EyebrowTone
  readonly className?: string
}

export function Eyebrow({ children, tone = EYEBROW_TONES.BRAND, className }: EyebrowProps) {
  return (
    <span className={cx(styles.eyebrow, styles[tone], className)}>
      <span className={styles.dot} aria-hidden="true" />
      {children}
    </span>
  )
}
